import { IPublicTypeContainerSchema } from './';

/**
 * 页面容器
 * @see https://lowcode-engine.cn/lowcode
 */
export interface IPublicTypePageSchema extends IPublicTypeContainerSchema {
  componentName: 'Page';
}
